var _a;
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Show } from '../icons/icons/Show';
import { Hide } from '../icons/icons/Hide';
import { Input } from '../Input/Input';
export var InputPassword = styled((_a = /** @class */ (function (_super) {
        __extends(InputPassword, _super);
        function InputPassword() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.inputComponentRef = React.createRef();
            _this.state = {
                type: 'password',
            };
            _this.handlePasswordToggle = function (e) {
                e.preventDefault();
                var type = _this.state.type;
                window.clearTimeout(_this.resetStateAfterBlur);
                _this.setState({
                    type: type === 'text' ? 'password' : 'text',
                });
            };
            _this.handleBlur = function (event) {
                var onBlur = _this.props.onBlur;
                _this.resetStateAfterBlur = window.setTimeout(function () {
                    return _this.setState({
                        type: 'password',
                    });
                }, 100);
                if (onBlur) {
                    onBlur(event);
                }
            };
            return _this;
        }
        InputPassword.prototype.componentWillUnmount = function () {
            window.clearTimeout(this.resetStateAfterBlur);
        };
        InputPassword.prototype.render = function () {
            var _a = this.props, _type = _a.type, showLabel = _a.showLabel, hideLabel = _a.hideLabel, props = __rest(_a, ["type", "showLabel", "hideLabel"]); // eslint-disable-line react/prop-types
            var type = this.state.type;
            var typeIsPassword = type === 'password';
            return (React.createElement(Input, __assign({}, props, { ref: this.inputComponentRef, type: type, onBlur: this.handleBlur, Icon: typeIsPassword ? Show : Hide, iconLabel: typeIsPassword ? showLabel : hideLabel, onIconClick: this.handlePasswordToggle })));
        };
        return InputPassword;
    }(React.Component)),
    _a.HIDE_PASSWORD_AFTER_TOUCH = 2000,
    _a))();
InputPassword.propTypes = __assign(__assign({}, Input.propTypes), { showLabel: PropTypes.string.isRequired, hideLabel: PropTypes.string.isRequired });
//# sourceMappingURL=InputPassword.js.map